import React, { useState } from 'react';
import { setAuthToken } from './authToken';
import { API_BASE_URL } from './config';

function AuthTokenPanel({ onLogin, onClose }) {
  const [token, setToken] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setAuthToken(token);
    try {
      const resp = await fetch(`${API_BASE_URL}/authtest`, {
        headers: { 'Authorization': token }
      });
      if (resp.ok) {
        if (onLogin) onLogin(token);
        if (onClose) onClose();
      } else {
        setError('Niepoprawny token lub brak uprawnień.');
      }
    } catch (err) {
      setError('Błąd połączenia z serwerem.');
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        background: '#fff',
        borderRadius: 20,
        padding: 32,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        minWidth: 250,
        position: 'relative'
      }}
    >
      <button
        type="button"
        onClick={onClose}
        style={{
          position: 'absolute',
          top: 8,
          right: 8,
          background: 'none',
          border: 'none',
          fontSize: '1.5rem',
          cursor: 'pointer'
        }}
        aria-label="Close login"
      >×</button>
      <h2 style={{ textAlign: 'center' }}>Podaj token</h2>
      <input
        type="text"
        placeholder="Authorization..."
        value={token}
        onChange={e => setToken(e.target.value)}
        style={{ width: '100%', margin: '8px 0', padding: 8, borderRadius: 8, border: '1px solid #bbb' }}
        autoFocus
      />
      {error && (
        <div style={{ color: 'red', margin: '8px 0', textAlign: 'center' }}>{error}</div>
      )}
      <button
        type="submit"
        style={{
          width: '100%',
          background: '#333',
          color: '#fff',
          border: 'none',
          borderRadius: 8,
          padding: 10,
          marginTop: 12,
          fontWeight: 'bold',
          cursor: 'pointer'
        }}
      >
        Zaloguj
      </button>
    </form>
  );
}

export default AuthTokenPanel;